import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from './Header';
import SideMenu from './SideMenu';
import '../../css/Admin.css';

const AdminLayout = ({ children }) => {
  return (
    <div className="admin-layout">
      <Header />
      <Container fluid className="admin-container px-3">
        <Row>
          <Col xs="12" md="3" lg="2" className="admin-sidebar">
            <SideMenu />
          </Col>
          <Col xs="12" md="9" lg="10" className="admin-main">
            {children}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminLayout;